const IS_LOADING = "lists/segment_types/IS_LOADING";
const IS_ERROR = "lists/segment_types/IS_ERROR";
const DATA = "lists/segment_types/DATA";
const EDIT = "lists/segment_types/EDIT";

export { IS_LOADING, IS_ERROR, DATA, EDIT };
